import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface RegistrationState {
  email: string;
  password: string;
  confirmPassword: string;
  role: string;
  name: string;
  phone: string;
}

const initialState: RegistrationState = {
  email: "",
  password: "",
  confirmPassword: "",
  role: "",
  name: "",
  phone: ""
};

const registrationSlice = createSlice({
  name: "registration",
  initialState,
  reducers: {
    setStepOneData: (
      state,
      action: PayloadAction<{
        email: string;
        password: string;
        confirmPassword: string;
      }>
    ) => {
      state.email = action.payload.email;
      state.password = action.payload.password;
      state.confirmPassword = action.payload.confirmPassword;
    },
    setStepTwoData: (state, action: PayloadAction<{ role: string }>) => {
      state.role = action.payload.role;
    },
    setStepThreeData: (
      state,
      action: PayloadAction<{ name: string; phone: string }>
    ) => {
      state.name = action.payload.name;
      state.phone = action.payload.phone;
    },
    clearRegistrationData: (state) => {
      state.email = "";
      state.password = "";
      state.confirmPassword = "";
      state.role = "";
      state.name = "";
      state.phone = "";
    }
  }
});

export const {
  setStepOneData,
  setStepTwoData,
  setStepThreeData,
  clearRegistrationData
} = registrationSlice.actions;

export default registrationSlice.reducer;

// import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// interface RegistrationState {
//   email: string;
//   password: string;
//   confirmPassword: string;
//   role: string;
//   name: string;
//   phone: string;
// }

// const initialState: RegistrationState = {
//   email: "",
//   password: "",
//   confirmPassword: "",
//   role: "",
//   name: "",
//   phone: ""
// };

// const registrationSlice = createSlice({
//   name: "registration",
//   initialState,
//   reducers: {
//     setStepOneData: (
//       state,
//       action: PayloadAction<{
//         email: string;
//         password: string;
//         confirmPassword: string;
//       }>
//     ) => {
//       state.email = action.payload.email;
//       state.password = action.payload.password;
//       state.confirmPassword = action.payload.confirmPassword;
//     },
//     setStepTwoData: (state, action: PayloadAction<{ role: string }>) => {
//       state.role = action.payload.role;
//     },
//     setStepThreeData: (
//       state,
//       action: PayloadAction<{ name: string; phone: string }>
//     ) => {
//       state.name = action.payload.name;
//       state.phone = action.payload.phone;
//     }
//   }
// });

// export const { setStepOneData, setStepTwoData, setStepThreeData } =
//   registrationSlice.actions;

// export default registrationSlice.reducer;
